<template>
	<section class="app index">
		<IndexNavigation v-if="!isAuthenticated" />
		<router-view></router-view>
	</section>
</template>

<script>
import IndexNavigation from './IndexNavigation';
import { mapGetters } from 'vuex';

export default {
	name: 'IndexPage',
	components: {
		IndexNavigation,
	},
	computed: {
		...mapGetters(['isAuthenticated']),
	},
};
</script>